<template>
    <div id="page-container">
        <main id="main-container">
            <div class="bg-image" style="background-image: url('assets/media/photos/photo19@2x.jpg');">
                <div class="row no-gutters bg-gd-aqua">
                    <div class="hero-static col-md-6 d-flex align-items-center bg-white">
                        <div class="p-3 w-100">
                            <div class="text-center">
                                <a class="link-fx text-primary font-w700 font-size-h1" href="/">
                                    <span class="text-dark">Emali</span><span class="text-warning">fy</span>
                                </a>
                                <p class="text-uppercase font-w700 font-size-sm text-muted">Password Reset</p>
                            </div>
                            <div class="row no-gutters justify-content-center">
                                <div class="col-sm-8 col-xl-6">
                                    <el-form :rules="rules" :model="form" ref="password-reset">
                                        <div class="form-group">
                                            <el-form-item prop="password">
                                                <el-input :type="inputType" v-model="form.password"  placeholder="Your new password" suffix-icon="si si-lock">
                                                    <el-button @click="showPassword" slot="append" icon="si si-eye"></el-button>
                                                </el-input>
                                                <password v-model="form.password" :strength-meter-only="true"/>
                                            </el-form-item>
                                        </div>
                                        <div class="form-group text-center">
                                            <button @click.prevent="resetPassword" class="btn btn-block btn-hero-danger">
                                                <i class="fa fa-fw fa-check mr-1"></i> Reset Password
                                            </button>
                                            <p class="mt-3 mb-0 d-lg-flex justify-content-lg-between">
                                                <router-link class="btn btn-sm btn-light d-block d-lg-inline-block mb-1" to="/login">
                                                    <i class="fa fa-sign-in-alt text-muted mr-1"></i> Sign In
                                                </router-link>
                                                <router-link class="btn btn-sm btn-light d-block d-lg-inline-block mb-1" to="/register">
                                                    <i class="fa fa-plus text-muted mr-1"></i> New Account
                                                </router-link>
                                            </p>
                                        </div>
                                    </el-form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="hero-static col-md-6 d-none d-md-flex align-items-md-center justify-content-md-center text-md-center">
                        <div class="p-3">

                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>

</template>

<script>
    import Password from 'vue-password-strength-meter'

    export default {
        name: "PasswordReminder",
        components: {
          Password
        },
        data() {
            return {
                passwordIsVisible: false,
                inputType: 'password',
                rules: {
                    password: 'required|min:6|max:32',
                },
                form: {
                    email: '',
                    token: '',
                    password: '',
                }
            }
        },
        mounted() {
            let email = this.$route.query.email, token = this.$route.query.token;
            if(typeof email !== 'undefined' && typeof token !== 'undefined') {
                this.form.email = email;
                this.form.token = token;
            }
        },
        methods: {
            showPassword() {
                this.inputType = !this.passwordIsVisible ? 'text' : 'password';
                this.passwordIsVisible = !this.passwordIsVisible;
            },
            /**
             * Submit reset
             */
            resetPassword() {
                this.$refs['password-reset'].validate(valid => {
                    if (valid) {
                        axios.post('password/reset', this.form).then(response => {
                            this.$notify.success({
                                title: 'Password Reset',
                                message: 'The password to your account has been reset. Try logging in with your new password',
                                duration: 10000
                            });
                            this.$router.replace('/login');
                        }).catch( error => {
                            if(error.response && error.response.status === 422) {
                                this.$notify.error({
                                    title: error.response.data.message,
                                    message: error.response.data.errors.email[0]
                                })
                            }
                        })
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
